import { useQuery } from "@tanstack/react-query";

import type { PaymentSource } from "features/payment-methods/types";

import { get, HTTPError } from "common/helpers/HTTP";
import useAppStore from "common/hooks/useAppStore";

async function getPrimaryPaymentSource(): Promise<PaymentSource> {
  try {
    const { payment_source: paymentSource } = await get(
      `subscriptions/payment-source`,
    );

    // This is a temporary fix, until the backend resolves the issue with correct caching of payment source, when the card is removed through Chargebee
    return paymentSource.type ? paymentSource : null;
  } catch (err) {
    if (err instanceof HTTPError && err.code === 404) {
      return null;
    }
    throw err;
  }
}

export default function usePrimaryPaymentSource() {
  const isPaymentMethodHidden = useAppStore(
    (state) => state.debugOptions.isPaymentMethodHidden,
  );

  const {
    data: primaryPaymentSource,
    isLoading: isLoadingPrimaryPaymentSource,
  } = useQuery({
    queryKey: ["primaryPaymentSource"],
    queryFn: getPrimaryPaymentSource,
  });

  return {
    primaryPaymentSource: isPaymentMethodHidden ? null : primaryPaymentSource,
    isLoadingPrimaryPaymentSource,
  };
}
